import filesApi from '@/services/api/filesApi';

const initialState = () => ({
  items: [],
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async uploadFile({ commit }, { formData, bucket }) {
      try {
        const response = await filesApi.uploadFile({ formData, bucket });
        commit('addItem', response);
        return response;
      } catch (err) {
        commit('notifications/addNotifyErrors', ['Ошибка загрузки изображения'], { root: true });
        return Promise.reject(err);
      }
    },
  },
  mutations: {
    addItem(state, item) {
      if (!state.items.find((f) => f.filename === item.filename)) {
        state.items.push(item);
      }
    },
    clearState(state) {
      Object.entries(initialState()).forEach(([key, value]) => { state[key] = value; });
    },
  },
  getters: {
    items: (state) => state.items.sort((a, b) => a.filename - b.filename),
    getItemByFileName: (state) => (fileName) => state.items.find((x) => x.filename === fileName),
  },
};
